import { ActionTree } from "vuex";
import { ActionTypes } from "./actions-types";
import { MutationTypes } from "./mutations-types";
import Client from "@/plugins/axios/axios";
import { Auth_login } from "@/types/auth";
import { AuthActionsTypes, AuthStateType } from "./interface";
import { Response_ } from "@/plugins/axios/response";

export const actions: ActionTree<AuthStateType, AuthStateType> & AuthActionsTypes = {
  [ActionTypes.AUTH_LOGIN]: async ({ commit }, payload: Auth_login): Promise<Response_> => {
    return Client.post<unknown, Response_>(`user/authentication`, payload)
      .then((response: Response_) => response)
      .catch((err: Response_) => err);
  },
  [ActionTypes.DECONNEXION]: async ({ commit }): Promise<void> => {
    await Client.get(`user/deconnexion`);
    commit(MutationTypes.IS_LOGGED_IN, false);
  },
  [ActionTypes.VERIFY_AUTH]: async ({ commit }): Promise<void> => {
    return Client.post(`token/verify_token`, {})
      .then(() => commit(MutationTypes.IS_LOGGED_IN, true))
      .catch(() => commit(MutationTypes.IS_LOGGED_IN, false));
  },
  [ActionTypes.REFRESH_AUTH]: async ({ commit }): Promise<void> => {
    return Client.post(`token/refresh_token`, {});
  },
  [ActionTypes.VERIFY_TEMPORARY_TOKEN]: async ({ commit }, temporary_token: string): Promise<number> => {
    return Client.post<number, Response_>(`token/verify_temporary_token?temporary_token=${temporary_token}`, {})
      .then((response: Response_) => response.status)
      .catch((err: Response_) => err.status);
  },
  [ActionTypes.RESET_PASSWORD]: async ({ commit }, payload: any): Promise<number> => {
    return Client.patch(`user/reset_actual_password?temporary_token=${payload.temporary_token}`, {
      password: payload.password
    })
      .then((response) => response.status)
      .catch((err) => {
        if (err.response.status === undefined) return 500;
        return err.response.status;
      });
  },
  [ActionTypes.SET_VIEW]: ({ commit }, view: string): void => {
    commit(MutationTypes.CHANGE_VIEW_TYPE, view);
  }
};
